<template>
  <div :class="['gridly-box', uploadType == 'small' ? 'gridly-box-small' : 'gridly-box-flex']">
    <div class="pic-list-box">
      <template  v-if="picList.length">
        <div class="gridly-item item" v-for="(obj, key) in picList" :key="obj.key" v-bind:data-id="obj.id" v-bind:id="'imgDivShowImageUrl' + obj.id" draggable="true" @dragstart="handleDragStart($event, obj)" @dragover.prevent="handleDragOver($event, obj)" @dragenter="handleDragEnter($event, obj)" @dragend="handleDragEnd($event, obj)">
          <div class="thumbnail" v-bind:class="[key <= 0 ? 'img-selected' : '']" style="width: 100%; height: 100%">
            <el-image class="card-pic" v-bind:data-id="obj.id" v-bind:src="obj.ImageUrl" fit="contain"></el-image>
            <a href="javascript:void(0);" class="dltImg" role="button" @click="dltImgDiv('imgDivShowImageUrl' + obj.id, 'uploadShowImageUrl', obj.id, key)">
              <img src="/static/images/close.png" />
            </a>
          </div>
        </div>
      </template>
      <el-upload v-if="uploadType != 'small' ? picList.length < picListLimit ? true : false : true" :class="['up-img-btn', 'pull-left', border ? 'border' : '']" ref="upload" action="" :http-request="uploadImg" list-type="picture" :show-file-list="false" :limit="picListLimit" :on-exceed="handleExceed" :file-list="picList" :before-upload="beforeUpload" :on-success="uploadImgSuccess" :on-error="uploadImgError" :on-remove="handleRemove" :with-credentials="true">
        <img :src="uploadType == 'small' ? '/static/images/icon/icon_picture.svg' : '/static/images/upload/add.png'" />
        <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
      </el-upload>
    </div>
  </div>
</template>
<script>
import VueCookie from 'vue-cookie'
import Guid from 'guid';
import COS from 'cos-js-sdk-v5'
//var COS = require('cos-js-sdk-v5');
let cos = "";
let cosData = "";
import qs from 'qs';
export default {
  name: 'UploadImages',
  data() {
    return {
      picList: [...this.parentPicList], //图片列表
      FormData: {}, //表单提交值
      //uploadUrl: process.env.VUE_APP_WORLDURL + '/NewCommodity/UploadImage',//&token=+this.$store.state.ChToken
      cosConfig: this.$enumInfo.cosConfig,
      dragging: null,
      minImgWidth: 300,
      minImgHeight: 300,
    }
  },
  props: {
    parentPicList: {
      type: Array,
      default: []
    },  //图片列表
    picListLimit: {
      type: Number,
      default: 3
    },
    needReturn: {
      type: Boolean,
      default: false
    },//是否返回父组件图片列表
    border: {
      type: Boolean,
      default: false
    },//是否显示上传按钮边框
    uploadType: {
      type: String,
      default: ''
    }
  },
  watch: {
    parentPicList(val) {
      this.picList = [...val]
    }
  },
  created() {
    let that = this
    that.NowCos()
  },
  methods: {
    NowCos() {
      let that = this
      cos = new COS({
        getAuthorization: function (options, callback) {
          if (that.$cookie.get("cosData")) {
            cosData = JSON.parse(that.$cookie.get("cosData"));
            //console.log("$cookie.get.costoken", cosData);
            var credentials = cosData.Credentials;
            var cb = {
              TmpSecretId: credentials.TmpSecretId,
              TmpSecretKey: credentials.TmpSecretKey,
              SecurityToken: credentials.Token,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: parseInt(cosData.StartTime), // 时间戳，单位秒，开始时间，即获取时刻的时间戳
              ExpiredTime: parseInt(cosData.ExpiredTime) // 时间戳，单位秒，超时时刻的时间戳
            }
            //console.log("callback",cb);
            callback(cb);
          } else {
            that.$get(that.$interface.costoken, '').then(res => {
              console.log("costoken", res);
              try {
                cosData = res;
                that.$cookie.set("cosData", JSON.stringify(res), { expires: new Date(new Date().getTime() + 1.5 * 60 * 60 * 1000) });
                //console.log("getAuthorization2 - data", cosData);
                var credentials = cosData.Credentials;
              } catch (e) { }
              if (!cosData || !credentials) {
                return console.error('credentials invalid:\n' + cosData)
              };
              var cb = {
                TmpSecretId: credentials.TmpSecretId,
                TmpSecretKey: credentials.TmpSecretKey,
                SecurityToken: credentials.Token,
                // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                StartTime: parseInt(cosData.StartTime), // 时间戳，单位秒，开始时间，即获取时刻的时间戳
                ExpiredTime: parseInt(cosData.ExpiredTime) // 时间戳，单位秒，超时时刻的时间戳
              }
              //console.log("callback",cb);
              callback(cb);
            })
          }
        }
      })
      console.log('COS:', cos)
    },
    // 展示图上传

    beforeUpload(file) {
      var that = this;
      //测试
      // that.picList = [...that.picList, {
      //   id: new Date().getTime(),
      //   ImageUrl: 'https://images.cardhobby.com/3811b22ab5424d8e8adfb2ef7e4407e7.jpeg',
      //   type: 1,
      //   Sort: 0,
      // }]
      // that.setPic2Form();
      //测试
      //console.log(file);
      var isJPG = file.type === "image/jpeg" || file.type === "image/png";
      var isLt5M = file.size / (1024 * 1024 * 5) < 5;

      if (!isJPG) {
        that.$message.warning("上传头像图片只能是 JPG/PNG 格式!");
        return false;
      }
      if (!isLt5M) {
        that.$message.warning("上传头像图片大小不能超过 5MB!");
        return false;
      }
      //that.$message.error('上传图片分辨率建议800*600以上!');

      var isSize = that.uploadWidth(file);
      return isJPG && isLt5M && isSize;
    },
    uploadWidth(file) {
      //判断上传图片width、height限制
      var that = this;
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let image = new Image();
        image.onload = function () {
          //控制图片上传大小方法
          var _imgWidth = image.width;
          var _imgHeight = image.height;
          //console.log(_imgWidth, _imgHeight);
          let valid = _imgWidth < that.minImgWidth || _imgHeight < that.minImgHeight ? false : true;
          valid ? resolve() : reject();
        };
        image.src = _URL.createObjectURL(file);
      }).then(
        function () {
          //that.uploadFile.append('file', file);
          that.uploadFile = file;
          return file;
        },
        function () {
          that.$message.warning("上传图片分辨率建议800*600以上!");
          return Promise.reject();
        }
      );
      return isSize;
    },
    uploadImg(param) {
      var that = this;

      var uploadType = process.env.NODE_ENV == "development" ? "api" : "cos"; //cos api
      if (uploadType == "cos") {
        var myGuid = Guid.raw();
        var fileType = that.uploadFile.type == 'image/png' ? ".png" : '.jpg';
        var imgKey = that.cosConfig.Prefix + myGuid.replace(/-/g, "") + fileType;
        cos.putObject({
          Bucket: that.cosConfig.Bucket,
          /* 必须 */
          Region: that.cosConfig.Region,
          /* 存储桶所在地域，必须字段 */
          Key: imgKey,
          /* 必须 */
          Prefix: that.cosConfig.Prefix,
          StorageClass: 'STANDARD',
          Body: that.uploadFile, // 上传文件对象
          Headers: {
            'x-cos-request-id': cosData.RequestId
          },
          onProgress: function (progressData) {
            console.log("onProgress:", JSON.stringify(progressData));
          },
        },
          function (err, data) {
            console.log("err", err);
            console.log("data", data);
            if (err) {
              that.$message.error(this.$t('alert.phoneUrlFail'));
            } else {
              let ImagesUrl = that.cosConfig.ImagesUrl + imgKey
              var _sort = that.picList.length ? 1 : that.picList.length + 1;
              var _type = that.picList.length ? 1 : 3;
              that.picList = [
                ...that.picList,
                {
                  id: new Date().getTime(),
                  ImageUrl: ImagesUrl,
                  type: _type,
                  Sort: _sort,
                },
              ];
              that.setPic2Form();
            }

          })
      } else {
        var fd = new FormData();
        fd.append('file', that.uploadFile);
        //console.log(that.uploadFile, 'file')
        this.$post(this.$interface.UploadImage, fd).then(res => {
          if (res.result) {
            var _sort = that.picList.length ? 1 : that.picList.length + 1;
            var _type = that.picList.length ? 1 : 3;
            that.picList = [
              ...that.picList,
              {
                id: new Date().getTime(),
                ImageUrl: res.data,
                type: _type,
                Sort: _sort,
              },
            ];
            that.setPic2Form();
            //console.log(1111, res)
          } else {
            console.log(response, file);
            this.$message.error("请求图片地址失败");
          }
        })
      }
    },
    uploadImgSuccess(response, file, fileList) {
      var that = this;
      //console.log('----uploadImgSuccess---');
      if (file.status == "success") {
        var _sort = that.picList.length ? 1 : that.picList.length + 1;
        var _type = that.picList.length ? 1 : 3;
        that.picList = [
          ...that.picList,
          {
            id: new Date().getTime(),
            ImageUrl: file.response.data,
            type: _type,
            Sort: _sort,
          },
        ];
        that.setPic2Form();
      } else {
        console.log(response, file);
        this.$message.error("请求图片地址失败");
        //测试
        //that.picList = [...that.picList, { id: new Date().getTime(), url: '/Content/img/thumbA.jpg', type: 1 }]
        //测试
      }
    },
    uploadImgError(err, file, fileList) {
      console.log("----uploadImgError---");
      console.log(err, file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传 ${this.picListLimit} 张图片`);
      //this.$message.warning(`当前限制选择 5 张，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}?`);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // 展示图拖曳
    handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd(e, item) {
      this.dragging = null;
    },
    //首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOver(e) {
      e.dataTransfer.dropEffect = "move"; // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    handleDragEnter(e, item) {
      var that = this;
      e.dataTransfer.effectAllowed = "move"; //为需要移动的元素设置dragstart事件
      if (item === this.dragging) {
        return;
      }
      var newItems = [...this.picList];
      //console.log(newItems)
      var src = newItems.indexOf(this.dragging);
      var dst = newItems.indexOf(item);
      newItems.splice(dst, 0, ...newItems.splice(src, 1));

      newItems = newItems.filter(function (obj, key) {
        obj["Sort"] = key + 1;
        if (key <= 0) {
          obj["type"] = 3;
        } else {
          obj["type"] = 1;
        }
        return obj;
      });
      this.picList = newItems;
      that.setPic2Form(); //图片写入FormData
      //console.log("handleDragEnter:FormData:",that.FormData);
    },
    // 展示图拖曳end
    setPic2Form(list) {
      var that = this;
      var _picList = list || this.picList;
      that.$set(that.FormData, "NewCommunityImages", _picList); //图片写入FormData
      if (that.needReturn) {
        that.returnImgs()
      }
    },
    dltImgDiv(id, uploadId, valId, valKey) {
      //console.log("fun dltImgDiv:", id, uploadId, valId, valKey);
      var that = this;
      var _picList = this.picList;
      _picList = _picList.filter(function (obj, kk) {
        //console.log(valId, obj.id);
        if (valId != obj.id) {
          return obj;
        }
      });
      this.picList = _picList;
      that.setPic2Form();
      //deleteImageDiv(id, uploadId);//public.js
    },
    returnImgs() {
      this.$emit('returnImgs', this.picList);
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dltImg {
  position: absolute;
  top: 3px;
    right: 2px;
    width: 18px;
    height: 18px;
    display: flex;
}

.dltImg img {
  width: 100%;
  height: auto;
}

.gridly-box {
  width: 100%;
  position: relative;
}

.gridly-box-flex {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.pic-list-box {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 22px;
}

.gridly-item {
  transition: all linear 0.3s;
  /* margin: 0 10px 5px 0; */
  width: 100px;
  height: 100px;
  border: 1px solid #f4f4f4;
}

.thumbnail {
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0;
}

.card-pic {
  width: 100%;
  height: auto;
}

.up-img-btn {
  cursor: pointer;
  width: 100px;
  height: 100px;
  display: flex;
  align-content: center;
  align-items: center;
  border-radius: 4px;
  color: #a0a0a0;
  font-size: 14px;
  flex-direction: column;
  justify-content: center;
}

.up-img-btn.border {
  border: 1px solid #ededed;
}

.up-img-btn img {
  width: 100%;
}

.up-img-btn.border img {
  width: 50%;
  margin-top: 12px;
}

/* input[type="file"].el-upload__input {
  display: none;
} */
.gridly-box .el-upload.el-upload--picture {
  width: 100%;
  height: 100%;
}

.el-icon-plus {
  font-size: 32px;
}

/* small style*/
.gridly-box-small .up-img-btn {
  width: 25px;
  height: 25px;
}

.gridly-box-small .gridly-item {
  width: 50px;
  height: 50px;
}

.gridly-box-small .dltImg {
  width: 12px;
  height: 12px;
}

.gridly-box-small .pic-list-box {
  position: absolute;
  top: -300%;
  background: rgba(255, 255, 255, 0.6);
  width: calc(100% - 8px);
  padding: 5px 0;
  left: -1%;
  z-index: 2;
}

.gridly-box-small .dltImg {
  display: none;
}

.gridly-box-small .gridly-item:hover .dltImg {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/upload-images.vue